import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/pure-plank/the_result.webp";

function Theresultplank() {
  return (
    <section
      className="theresult_plank text_whitegreen back_black"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={7} xl={6} xxl={6} className="my-auto">
            <div className="the_result_content">
              <h2>The Result</h2>
              <p>
                The Plank app is one of a kind and built to perfection. From the
                beginning till the end, the application was built as per the
                instructions of the client and market best practices. From
                maintaining and managing the profile to notifications to workout
                charts and progress reviews, every feature was seamlessly
                integrated to keep the experience unmatched. Focused on
                delivering all the information and guidance on the planking
                exercise, the Plank app and the platform features video
                tutorials, challenges, and much more to keep the users engaged
                and keep their motivation level high.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Theresultplank;
